const topics = [
  { label: '韩漫', hot: true, count: '586部', icon: 'ri-flag-line' },
  { label: '日漫', hot: true, count: '1240部', icon: 'ri-sun-line' },
  { label: '国漫', hot: true, count: '432部', icon: 'ri-star-line' },
  { label: '热血', hot: true, count: '热门连载', icon: 'ri-fire-line' },
  { label: '恋爱', hot: false, count: '人气推荐', icon: 'ri-heart-line' },
  { label: '奇幻', hot: true, count: '新番速递', icon: 'ri-magic-line' },
  { label: '悬疑', hot: false, count: '高分必看', icon: 'ri-search-eye-line' },
  { label: '搞笑', hot: false, count: '轻松日常', icon: 'ri-emotion-laugh-line' },
  { label: '都市', hot: false, count: '职场生活', icon: 'ri-building-line' },
  { label: '武侠', hot: true, count: '经典回顾', icon: 'ri-sword-line' },
  { label: '穿越', hot: true, count: '异世界', icon: 'ri-rocket-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门话题分类
        </h2>
        <p className="text-foreground-500 text-sm md:text-base text-center mb-10">
          按标签发现你感兴趣的漫画类型，韩漫日漫国漫一网打尽
        </p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group relative flex items-center gap-2.5 px-5 py-3 rounded-full bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/60 transition-all cursor-pointer"
            >
              {topic.hot && (
                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-primary-500 rounded-full flex items-center justify-center">
                  <span className="block w-1.5 h-1.5 bg-white rounded-full" />
                </span>
              )}
              <span className="w-7 h-7 flex items-center justify-center text-primary-500">
                <i className={`${topic.icon} text-lg`}></i>
              </span>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}